import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { PopupRequest, PromptValue, RedirectRequest } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { b2cPolicies } from 'src/app/config/auth-config';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private cookieService: CookieService,
        private msalService: MsalService,
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    ) {}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                let errMsg = '';
                // Client Side Error
                if (error.error instanceof ErrorEvent) {
                    errMsg = `Error: ${error.error.message}`;
                } else if ([401, 402, 403].indexOf(error.status) !== -1) {
                    errMsg = 'Unauthorized - Redirectng to login';
                    //this.msalService.logout();
                    this.cookieService.deleteAll();
                    sessionStorage.clear();
                    localStorage.clear();
                    //alert('logout');
                    // debugger;
                    const signUpSignInFlowRequest: PopupRequest = {
                        authority: b2cPolicies.authorities.signUpSignIn.authority,
                        prompt: PromptValue.LOGIN, // force user to reauthenticate with their new password
                        scopes: [],
                        redirectUri: environment.appUrl,
                    };
                    this.login(signUpSignInFlowRequest);
                    const fallbackResponse: any = {}; // Provide a meaningful default if needed.
                    return of(fallbackResponse);
                }
                return throwError(error);
            }),
        );
    }
    login(userFlowRequest?: RedirectRequest | PopupRequest) {
        this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest, ...userFlowRequest } as RedirectRequest);
    }
}
